import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Tab, TabList } from "react-aria-components";
import moment from "moment";
import { Tabs } from "../../components/core/basic/Tabs";
import { DatesContext, useDates } from "../../dates/DatesContext";
import { SQPRTargetTable, type SQPRTargetRow, type SQPRTargetType } from "./SQPRTargetTable";

interface ReportDates {
  start_date: string;
  end_date: string;
}

export const SearchQueryRowExpander = ({
  row,
  selectedReport,
  selectedCompareReport,
}: {
  row: SQPRTargetRow;
  selectedReport: ReportDates;
  selectedCompareReport?: ReportDates;
}) => {
  const { t } = useTranslation(["sqpr"]);
  // Per expander, so rows open side by side keep their own tab.
  const [tab, setTab] = useState<SQPRTargetType>("keyword");
  const parentDates = useDates();

  const datesOverride = useMemo(
    () => ({
      ...parentDates,
      start: moment(selectedReport.start_date),
      end: moment(selectedReport.end_date),
      preStart: selectedCompareReport ? moment(selectedCompareReport.start_date) : parentDates.preStart,
      preEnd: selectedCompareReport ? moment(selectedCompareReport.end_date) : parentDates.preEnd,
    }),
    [parentDates, selectedReport, selectedCompareReport],
  );

  return (
    <>
      <Tabs selectedKey={tab} onSelectionChange={(key) => setTab(key as SQPRTargetType)}>
        <TabList>
          <Tab id="keyword">{t(($) => $.sqpr["Keywords"])}</Tab>
          <Tab id="target">{t(($) => $.sqpr["Targets"])}</Tab>
        </TabList>
      </Tabs>
      <DatesContext.Provider value={datesOverride}>
        <SQPRTargetTable key={tab} targetType={tab} row={row} />
      </DatesContext.Provider>
    </>
  );
};
